import { Select } from 'farmhub-ui-core';
import styled from 'styled-components';

export const GroupInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  margin-bottom: 18px;

  border: 1px solid #d9d9d9;
  border-radius: 6px;

  .ant-select {
    box-shadow: none !important;
  }

  .ant-select-selector {
    border: 0px solid #ffffff !important;

    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  .ant-input {
    border: 0px solid #ffffff !important;

    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;

    &:focus {
      box-shadow: none !important;
    }
  }

  .ant-form-item-explain.ant-form-item-explain-connected {
    display: none !important;
  }

  &:has(.ant-form-item-explain-error) {
    border: 1px solid ${props => props.theme.colors.error.main};
  }
`;

export const SelectCustom = styled(Select)<{ dropdownRender: any }>``;
